import type { NewsletterSubscription } from '@/types/newsletter';

import { getCleanRGIS } from './auth-utils';

export const fetchNewsletterSubscriptions = async (
	rgisCookie: string,
	productItemIds: string[],
): Promise<{
	subscriptions: NewsletterSubscription[];
}> => {
	if (productItemIds.length === 0) {
		return {
			subscriptions: [],
		};
	}

	const res = await fetch(`/.api/newsletters/subscriptions`, {
		body: JSON.stringify({
			productItemIds,
		}),
		headers: {
			'Content-Type': 'application/json',
			'X-RGIS': getCleanRGIS(rgisCookie),
		},
		method: 'POST',
	});
	if (!res.ok) {
		throw new Error(
			`[${res.status}] Invalid /newsletters/subscriptions response ${res.statusText ?? ''}`,
		);
	}

	return res.json();
};
